import { render, staticRenderFns } from "./StudentScheduler.vue?vue&type=template&id=a79997b8&scoped=true&"
import script from "./StudentScheduler.vue?vue&type=script&lang=js&"
export * from "./StudentScheduler.vue?vue&type=script&lang=js&"
import style0 from "./StudentScheduler.vue?vue&type=style&index=0&id=a79997b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../CommunityWebPortal/_app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79997b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a79997b8')) {
      api.createRecord('a79997b8', component.options)
    } else {
      api.reload('a79997b8', component.options)
    }
    module.hot.accept("./StudentScheduler.vue?vue&type=template&id=a79997b8&scoped=true&", function () {
      api.rerender('a79997b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "VueCommon/common-components/src/components/StudentScheduler/StudentScheduler.vue"
export default component.exports